import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
// vue-pdf-embed bundles its own pdfjs-dist instance with a separate GlobalWorkerOptions.
// It sets workerSrc to a data: URI of the bundled worker at startup. This data: URI
// must be allowed by both worker-src (Web Worker creation) and script-src (evaluated
// as a script in some browser/proxy environments). Both directives include 'data:' in
// scripts/heroku-start.js.
import { VueFinalModal, ModalsContainer } from 'vue-final-modal';
import 'vue-final-modal/style.css';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import router from './router/router'
import { Field, Form, ErrorMessage } from 'vee-validate';
import './plugins/vee-validate';
import { installModalCompat } from './plugins/modal-compat';
import { installSafeHtml } from './plugins/v-safe-html';
import { initAirbrake } from './services/airbrake';
import VueTippy from "vue-tippy";
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import lodash from 'lodash'
import ActionCableVue from 'actioncable-vue';

// Add additional themes.
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/translucent.css";
import "tabulator-tables/dist/css/tabulator.css";

// If no browser session is active (tab was closed) and the previous session
// was an LTI session, clear localStorage to prevent stale LTI auth from
// redirecting the user to the dashboard instead of the intended LTI destination.
if (!sessionStorage.getItem('session_active') && localStorage.getItem('lti_session')) {
  localStorage.clear();
}
// Mark this browser session as active. sessionStorage is cleared on tab/window
// close, so this flag will be absent the next time the app boots in a new tab.
sessionStorage.setItem('session_active', '1');

const app = createApp(App);

installModalCompat(app);
installSafeHtml(app);

app.use(store);
app.use(router);
app.use(Vue3Toastify, { autoClose: 3000 });
app.use(VueTippy, {
  directive: 'tippy',
  component: 'tippy',
});
app.use(VCalendar, {});

app.use(ActionCableVue, {
  debug: process.env.NODE_ENV !== 'production',
  debugLevel: 'error',
  connectionUrl: process.env.VUE_APP_ACTION_CABLE_URL,
  connectImmediately: true,
});

app.config.globalProperties.$lodash = lodash;

app.component('VueFinalModal', VueFinalModal);
app.component('ModalsContainer', ModalsContainer);
app.component('VeeForm', Form);
app.component('VeeField', Field);
app.component('VeeErrorMessage', ErrorMessage);

initAirbrake(app);

app.mount('#app');
